import { v4 } from 'uuid';

export function createDataLabel(): string {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return v4().split('-').shift()!;
}
